import { render, staticRenderFns } from "./TheBasicNavbarVertical.vue?vue&type=template&id=fdc6016c&scoped=true&"
import script from "./TheBasicNavbarVertical.vue?vue&type=script&lang=js&"
export * from "./TheBasicNavbarVertical.vue?vue&type=script&lang=js&"
import style0 from "./TheBasicNavbarVertical.vue?vue&type=style&index=0&id=fdc6016c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc6016c",
  null
  
)

export default component.exports